export default __webpack_public_path__ + "static/media/auriculares.39ee4c0c.jpg";